import NfcCardTransactionsScreen from './NfcCardTransactionsScreen';

export default NfcCardTransactionsScreen;
